// extracted by mini-css-extract-plugin
export default {"icon":"PZ4Rq","text":"xOtMV","button":"lG3LB","textButton":"dA2hY","iconButton":"uXclH","animated":"+N+KV","verticalAlign":"FJiKc"};